import { ReimbursementMethod } from 'domain/expenses/reimbursementMethod'
import { adminHttpClient } from '../../../commons/adminHttpClient'

export interface ReimbursePerksExpensesCommand {
  planPeriodId: string
  scheduledDate: string
  reimbursementMethod: ReimbursementMethod
  otherReimbursementMethod: string
  expenses: ExpenseRequest[]
}

export interface ExpenseRequest {
  companyUserId: string
  expenseCategoryId: number
  amount: number
}

const submitPerksReimbursementsDue = (reimbursementsDue: ReimbursePerksExpensesCommand): Promise<any> => {
  return adminHttpClient.post('/AdminDashboard/Perks/Reimbursements/ReimbursePerksExpenses', reimbursementsDue)
}

export default submitPerksReimbursementsDue
